<template>
  <li class="mini-cart-item p-2">
    <div class="mini-cart-img">
      <img :src="getImageUrl(prod.Image)" alt />
    </div>
    <div class="mini-cart-info">
      <small class="extra-small">
        <span>{{ prod.Title }}</span>
        <br />
        <span>Qty : {{ prod.orderQty }}</span>
        <br />
        <b>
          <u>AED&nbsp;{{ this.getProdPrice(prod.Price) }}</u>
        </b>
      </small>
      <br />
    </div>
    <b-row class="mr-0 pl-3">
      <small @click="editItem" class="ml-1 mr-4 mini-cart-action">Edit</small>
      <small @click="removeItem" class="mini-cart-action">Remove</small>
    </b-row>
  </li>
</template>

<script>
export default {
  name: "MiniCartProduct",
  props: ["prod"],
  methods: {
    a() {},
    editItem() {
      this.$router.push({ name: "Cart" });
      this.$emit("close-flyout");
    },
    removeItem() {
      this.$store.commit("removeFromCart", this.prod.id);
      this.$emit("mini-cart-remove");
    },
  },
};
</script>

<style>
.mini-cart-item {
  display: block !important;
  margin-left: 0;
  width: 20rem;
  overflow: hidden;
  max-height: 10.7142857143rem;
  padding-right: 1.4285714286rem;
}

.mini-cart-img {
  /* height: 3.4285714286rem; */
  height: 4rem;
  width: 3.4285714286rem;
  margin: 4px;
  float: left;
  position: relative;
}

.mini-cart-info {
  line-height: 1;
  float: left;
  width: 13.4285714286rem;
  text-align: left;
  margin: 8px;
}

.mini-cart-img img {
  width: 100%;
  max-height: 150px;
  object-fit: contain;
  object-position: center center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mini-cart-txt-extra-info {
  margin-top: -4px;
  font-weight: 100;
}

.mini-cart-action {
  cursor: pointer;
  text-decoration-line: underline;
}

/* 
.extra-small {
  font-size: 75%;
  font: small-caption;
} */
</style>
